
import { Question } from '../types';
import { getDB } from '../lib/db';
import { apiClient, isCloud } from '../lib/apiClient';

export const getQuestions = async (): Promise<Question[]> => {
  if (isCloud) {
    try {
      return await apiClient('/questions');
    } catch (e) { return []; }
  } else {
    const db = await getDB();
    return db.getAll('questions');
  }
};

export const saveQuestion = async (q: Question): Promise<void> => {
  if (isCloud) {
    await apiClient('/questions', {
      method: 'POST',
      body: JSON.stringify(q)
    });
  } else {
    const db = await getDB();
    await db.put('questions', q);
  }
};

export const deleteQuestion = async (id: string, hard: boolean = false): Promise<void> => {
  if (hard) {
    if (isCloud) {
       await apiClient(`/questions/${id}`, { method: 'DELETE' });
    } else {
       const db = await getDB();
       await db.delete('questions', id);
    }
  } else {
    // Soft delete
    const qs = await getQuestions();
    const q = qs.find(x => x.id === id);
    if (q) {
      q.deletedAt = Date.now();
      await saveQuestion(q);
    }
  }
};

export const restoreQuestion = async (id: string): Promise<void> => {
    const qs = await getQuestions();
    const q = qs.find(x => x.id === id);
    if (q) {
      delete q.deletedAt;
      await saveQuestion(q);
    }
};

export const hydrateQuestion = async (q: Question): Promise<Question> => {
    if (!q) return q;
    const needsMat = q.materials.some(m => m === '__IMAGE_REF__');
    const needsNote = q.notesImage === '__IMAGE_REF__';
    
    if (!needsMat && !needsNote) return q;

    if (isCloud) {
        try {
            const images = await apiClient(`/questions/${q.id}/images`);
            return {
                ...q,
                materials: images.materials || q.materials,
                notesImage: images.notesImage || q.notesImage
            };
        } catch(e) { console.error(e); return q; }
    }
    return q;
};
